<template>
	<div v-loading.fullscreen.lock="homeLoading" element-loading-text="页面载入……" element-loading-background="#ffffff">
	<div id="appbox" v-show="!homeLoading">
		
		
		<div class="top_heard"  >
			<!-- <div class="top_minemsgbox">
				<div class="top_institutionmsg">
					黑龙江省文化和旅游厅 | 黑龙江省研学实践教育协会
				</div>
				<div class="welcome">
					欢迎您访问：河南研学平台！
				</div>
				
			</div> -->
			<!--<div class="Site_switch" v-if="screenWidth>785">
				<el-select v-model="Site_url" @change="Siteurl"  size="small" class="Site_switch_type" placeholder="站点选择">
				  <el-option
				    v-for="item in Siteoptions"
				    :key="item.value"
				    :label="item.label"
				    :value="item.value"
					>
				  </el-option>
				</el-select>
			</div>-->
			<div class="top_box" v-if="screenWidth>785"  :style="screenWidth>785?'':'width:'+screenWidth+'px !important;'">
				<!-- <div class="Site_switch">
					<el-select v-model="Site_url" @change="Siteurl"  size="small" class="Site_switch_type" placeholder="站点选择">
					  <el-option
						v-for="item in Siteoptions"
						:key="item.value"
						:label="item.label"
						:value="item.value"
						>
					  </el-option>
					</el-select>
				</div>	 -->
				<div class="logo_box" >
					<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
				</div>
				<div class="top_gatebox" v-if="screenWidth>785">
	<!-- 				<div class="gatebutton">
						 <a href="https://admin.henanyanxue.com/"  target="_blank">
							<el-button style="border:1px solid #1b9d57; color: #1b9d57 ;" plain round >机构管理后台入口</el-button>
						 </a> 
						 <a href="http://xh.wanjiaxiao.cn/seeyon/index.jsp" style="margin-left:15px;"  target="_blank">
						 	<el-button style="border:1px solid #1b9d57; color: #1b9d57 ;" plain round >平台OA入口</el-button>
						 </a> 
					</div> -->
					<div class="manage_switch" v-if="screenWidth>785">
						<el-select v-model="manage_url" @change="manageurl"  size="small" class="Site_switch_type" placeholder="选择入口">
						  <el-option
						    v-for="item in manageoptions"
						    :key="item.value"
						    :label="item.label"
						    :value="item.value"
							>
						  </el-option>
						</el-select>
					</div>
					<div class="" >
						
						<!-- <el-button plain round>机构管理后台入口</el-button> -->
					</div>
				</div>
				<div class="top_search_box" v-if="screenWidth>785" >
					<div class="top_search">
						<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
						  <el-option
						    v-for="item in options"
						    :key="item.value"
						    :label="item.label"
						    :value="item.value"
							
							>
						  </el-option>
						</el-select>
						<!-- <i class="el-icon-search"></i> -->
						<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
						<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="gotopsearch()" alt="" srcset="">
					</div>
					  
				</div>
				<div class="top_right" v-if="screenWidth>785">
					<div class="top_Mobiletype" @click="goregister()">
						账号注册/绑定
					</div>
					<div class=""  v-if="token" >
						欢迎访问!
					</div>
					<div class=""  v-if="token"  style="color: darkred;margin-left: 5px;" @click="logout()" >
						登出
					</div>
				</div>
			</div>
			<MoveWindow />
			
			<div class="top_tab_box">
				<van-nav-bar title="" style="color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true" v-if="screenWidth<785" >
					<template #left>
						<div class="vannav_title" style="color: #217495;font-size: 16px;" >
							首页
						</div>
					</template>
					<template #title>
						<div class="vannav_title" style="width: 180px;padding: 20px;">
								<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
						</div>
					</template>
				  <template #right>
					  <van-icon name="ellipsis"  size="20"    />
				  </template>
				</van-nav-bar>
	<!-- 			<van-nav-bar title="" style="background-color:#1b9d57;color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true" v-if="screenWidth<785" >
					<template #left>
						<van-image
						  width="30"
						  height="30"
						  round
						  src="https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20231204/29ab0b27184d1d61dfce9e202ce0e0b2.jpg"
						/>
					</template>
					<template #title>
						<div class="vannav_title">
							首页
						</div>
					</template>
				  <template #right>
					  <van-icon name="ellipsis" color="#ffffff" size="18"    />
				  </template>
				</van-nav-bar> -->
				<van-popup v-model="vannavshow"  :style="{ height: '50%' }" position="top">
					<van-picker
					  title=""
					  show-toolbar
					  :columns="vannavlist"
					  confirm-button-text="进入"
					  @confirm="vanlinkgo"
					  @cancel="vannavmenushow"
					 
					/>
				</van-popup>
				<div class="toptabnav"  v-if="screenWidth>785" :style="screenWidth>785?'':'max-height: 210px;'">
						<el-menu
						  :default-active="activeIndex2"
						  class="el-menu-demo"
						  :style="screenWidth>785?'':'width:'+screenWidth+'px;flex-wrap:wrap;'"
						  mode="horizontal"
						  @select="handleSelect"
						  router
						  background-color="#1b9d57"
						  text-color="#FFFFFF"
						  active-text-color="#FFFFFF">
						<el-menu-item index="/Home"  >首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
						
						<el-submenu index="/institution">
						    <template slot="title">研学单位</template>
						    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
						    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
						    <el-menu-item index="/traveler" >研学机构</el-menu-item>
						  </el-submenu>
						
							<el-submenu index="/Courselist">
						    <template slot="title">研学产品</template>
						    <el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						  </el-submenu>
						  	<el-submenu index="/authLesson">
						    <template slot="title">认证申请</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/authLesson" >课程认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >基地认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >机构认证申请</el-menu-item>
						   
						  </el-submenu>
<!--						<el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
						<el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
						  
              			
						<el-menu-item index="/expertlist" >智库专家</el-menu-item>
             			<el-menu-item index="/OrgRegister" >入驻平台</el-menu-item>
						<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
					</el-menu>
				</div>
				<div class="top_banner">
					<el-carousel ref="carousel" :interval="4000"  :height="screenWidth>785?'480px':top_bannerWidth+'px'">
					  <el-carousel-item v-for="(item, key) in platelist" :key="key" >
					    <h3 class="medium" style="width: 100%;height: 100%;"><img :src="item.thumb"  style="width: 100%;height: 100%;" alt="" @click="gomodules(item.link)"></h3>
					  </el-carousel-item>
					</el-carousel>
				</div>
<!-- 				<div class="top_plate">
					<div class="plate_item" v-for="(plate, index) in platelist" :key="plate" @mouseover="showstep(index)" @click="goplate(plate.id)" >
						<div class="plate_icon">
							<img :src="plate.icon" alt="" srcset="">
						</div>
						<div class="plate_title">
							{{plate.title}}
						</div>
					</div>
				</div> -->
			</div>
		</div>
		<div class="Home_Notice" :style="screenWidth>785?'':'width:calc(100% - 40px);'" >
			<i class="el-icon-message-solid" style="color: #E6A23C;"></i>
			<div class="Notice_list" :style="screenWidth>785?'':'width:'+(screenWidth-100)+'px;'" >
				<el-carousel :height="screenWidth>785?'42px':'30px'" direction="vertical" :autoplay="true">
				  <el-carousel-item v-for="(item, key) in ntlist" :key="key">
				    <h3 class="medium" :style="screenWidth>785?'color: #1b9d57;line-height: 42px;font-size: 18px;':'color: #1b9d57;line-height: 30px;font-size: 12px;'" @click="gontdetails(item.id)" >{{ item.title }}</h3>
				  </el-carousel-item>
				</el-carousel>
			</div>
			<!-- <i class="el-icon-arrow-right"></i> -->
		</div>
		<div class="Home_column1" :style="screenWidth>785?'margin-top:20px;':'margin-top:20px;flex-direction: column;width:100%;'">
			<div class="Home_imgs" :style="screenWidth>575?'':'width:100%;'">
				<el-carousel :interval="4000" indicator-position="outside" :height="screenWidth>575?'370px':screenWidth/1.55+'px'">
				  <el-carousel-item v-for="(item, key) in banner" :key="key">
					<h3 class="medium" style="width: 100%;height: 100%;position: relative;"><img :src="item.icon"  style="width: 100%;height: 100%;" alt="" srcset="">
					<!-- <div class="home_banner_text">
						{{item.title}}
					</div> -->
					</h3>
				  </el-carousel-item>
				</el-carousel>
			</div>
			<div class="newnews_box" :style="screenWidth>575?'':'width:100%;'">
				  <el-tabs v-if="newstypes.length" v-model="newscategory_id" @tab-click="newshandleClick">
				    <el-tab-pane  v-for="(items, index) in newstypes"  :key="index"  :name="items.id+ ''"   :label="items.title" >
						<div class="newslist">
							<div class="news_item"  v-for="(item, key) in newslist" :key="key"  @click="gonews(item.id,item.link)"  >
								<span style="display: inline-block;padding: 0;min-width: 8px;height: 8px;width: 8px;background: #1b9d57;margin-right: 4px;"></span>{{item.title}}
							</div>
						</div>
					</el-tab-pane>
				  </el-tabs>
	<!-- 			<div class="news_top">
					<div class="news_title">
						最新消息
					</div>
					<div class="news_gomroe"  @click="gocolumn('/Newslist')">
						查看更多
					</div>
				</div> -->
	
			</div>
		</div>
		<div class="Home_advimgs" :style="screenWidth>785?'':'width:100%;'">
			<el-carousel :height="screenWidth>785?'139px':(screenWidth/8.48)+'px'" direction="vertical" :autoplay="true">
				<el-carousel-item v-for="(item, key) in advbanner" :key="key">
				  <h3 class="medium" :style="screenWidth>785?'width: 100%;height: 100%;':'width: 100%;height: 100%;line-height:'+(screenWidth/8.48)+'px;'" >
					  <img :src="item.icon"  style="width: 100%;height: 100%;" alt="" srcset="">
				  </h3>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="Home_column2" :style="screenWidth>785?'':'width:100%;'">
			<div class="column_titlebox" v-if="screenWidth<785"  :style="screenWidth>785?'':'width:100%;'">
				<div class="column_title">
					推荐研学课程
				</div>
				<div class="column_gomore"  @click="gocolumn('/Courselist')">
					查看更多 >
				</div>
			</div>
			<div class="column_titleicon"  v-if="screenWidth>785"  @click="gocolumn('/Courselist')">
				<img src="../../../static/img/研学课程.jpg" alt="" srcset="">
			</div>
			<div class="column2_box" :style="screenWidth>785?'':'width:100%;flex-wrap:wrap;zoom:'+((screenWidth/1180)*100+36)+'%'">
				<div :class="screenWidth>785?'column2_item':'column2_item'" :style="screenWidth>785?'position: relative;':'margin-bottom:15px;position: relative;'"   v-for="(item, key) in lessonlist" :key="key" @click="golesson(item.id)">
					<img src="../../../static/img/已认证.png" alt="" style="width: 45px;height: 35px;position: absolute;top:0px;left: 0px;z-index: 999;">
					<div class="column2_img">
						<img :src="item.icon" alt="" srcset="">
					</div>
					<div class="column2_title">
						<div class="item_title">
							{{item.title}}
						</div>
						<div class="item_subtitle">
							{{item.camp}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="Home_column2" :style="screenWidth>785?'':'zoom:'+((screenWidth/1180)*100-3)+'%'">
			<div class="column_titleicon" @click="goexpertlist()">
				<img src="../../../static/img/专家标题.jpg" alt="" srcset="">
			</div>
			<div class="expert_box">
				<swiper :options="swiperexpert" ref="mySwiper" v-if="expertlist.length">
				<!-- 	<div class="" > -->
						<swiper-slide v-for="(item, key) in expertlist" :key="key"  >
							<div class="expert_item"   :data-id="item.id">
								<div class="expert_img"  :data-id="item.id">
									<img :src="item.icon"  :data-id="item.id" alt="" srcset="">
								</div>
								<div class="hcamp_title"  :data-id="item.id">
									<div class="item_title" style="text-align: center;color: #1b9d57;"  :data-id="item.id">
										{{item.title}}
									</div>
								</div>
							</div>
						</swiper-slide>
				</swiper>
			</div>
		</div>
		<div class="Home_column2" :style="screenWidth>785?'':'width:100%;'">
			<div class="column_titlebox"  v-if="screenWidth<785" :style="screenWidth>785?'':'width:100%;'" >
				<div class="column_title">
					精品优质线路
				</div>
				<div class="column_gomore" @click="gocolumn('/Linelist')">
					查看更多
				</div>
			</div>
			<div class="column_titleicon"  v-if="screenWidth>785"  @click="gocolumn('/Linelist')">
				<img src="../../../static/img/线路.jpg" alt="" srcset="">
			</div>
			<div class="column2_box" :style="screenWidth>785?'':'width:100%;flex-wrap:wrap;zoom:'+((screenWidth/1180)*100+36)+'%'">
				<div class="column2_item" :style="screenWidth>785?'':'margin-bottom:15px;'"  v-for="(item, key) in linelist" :key="key" @click="goline(item.id)">
					<div class="column2_img">
						<img :src="item.icon" alt="" srcset="">
					</div>
					<div class="column2_title">
						<div class="item_title">
							{{item.title}}
						</div>
						<div class="item_subtitle">
							{{item.unit}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="Home_column2" :style="screenWidth>785?'':'width:100%;'">
			<div class="column_titlebox" v-if="screenWidth<785" :style="screenWidth>785?'':'width:100%;'">
				<div class="column_title">
					营地基地展示
				</div>
				<div class="column_gomore" @click="gocolumn('/Camplist')">
					查看更多
				</div>
			</div>
			<div class="column_titleicon"  v-if="screenWidth>785"  @click="gocolumn('/Camplist')">
				<img src="../../../static/img/特色基地营地.jpg" alt="" srcset="">
			</div>
			<div class="homecamp_list" :style="screenWidth>785?'':'width:calc(100% - 20px);'" >
				<div class="camp_swiperbox" v-if="Camplist.length>0" :style="screenWidth>785?'':'max-width:100%;zoom:'+((screenWidth/1180)*100+23)+'%'" >
					<swiper :options="swiperOption" ref="mySwiper" v-if="Camplist.length">
					<!-- 	<div class="" > -->
							<swiper-slide v-for="(item, key) in Camplist" :key="key"  >
								<div class="homecamp_item"   :data-id="item.id">
									<div class="column2_img" style="height: 143px;"  :data-id="item.id">
										<img :src="item.icon"  :data-id="item.id" alt="" srcset="">
									</div>
									<div class="hcamp_title"  :data-id="item.id">
										<div class="item_title" style="text-overflow: ellipsis;white-space: normal;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;min-height: 48px;"  :data-id="item.id">
											{{item.title}}
										</div>
										<div class="homecamp_msg" style="text-overflow: ellipsis;white-space: normal;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;"  :data-id="item.id">
											{{item.type+'地址:'+item.address}}
										</div>
									</div>
									<div class="hcamp_button"  :data-id="item.id">
										  <button class="el-button el-button--success el-button--small is-plain" size="small" :data-id="item.id" >查看详情</button>
									</div>
								</div>
							</swiper-slide>
						<!-- </div> -->
						<!-- <div class="swiper-pagination" slot="pagination"></div> -->
					</swiper>
				</div>
				<div class="camp_titleicon" v-if="screenWidth>785" >
					<img src="../../../static/img/营地图标.jpg" alt="" srcset="">
					<div class="camp_regionbox" >
						<div class="camp_regionitem"  v-for="(item, key) in regionlist" :key="key" @click="camptypego(item.id)" >
							{{item.title}}
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="column2_box">
				<div class="column2_item"   v-for="(item, key) in Camplist" :key="key" @click="gocamp(item.id)">
					<div class="column2_img">
						<img :src="item.icon" alt="" srcset="">
					</div>
					<div class="column2_title">
						<div class="item_title">
							{{item.title}}
						</div>
						<div class="item_subtitle">
							{{item.address}}
						</div>
					</div>
					<div class="camp_rank">
						{{item.type}}
					</div>
				</div>
			</div> -->
		</div>
		<div class="Home_column2" :style="screenWidth>785?'':'width:100%;'">
			<div class="column_titlebox" v-if="screenWidth<785" :style="screenWidth>785?'':'width:100%;'">
				<div class="column_title">
					优秀研学指导师
				</div>
				<div class="column_gomore" @click="gomentor()">
					查看更多
				</div>
			</div>
			<div class="column_titleicon"  v-if="screenWidth>785"  @click="gomentor()">
				<img src="../../../static/img/指导师.jpg" alt="" srcset="">
			</div>
			<div class="column2_box" :style="screenWidth>785?'':'width:100%;flex-wrap:wrap;zoom:'+((screenWidth/1180)*100+17)+'%'" >
				<div class="mentor_item"  :style="screenWidth>785?'':'margin-bottom:20px;'" v-for="(item, key) in mentorlist" :key="key">
					<div class="mentor_imgs">
						<img :src="item.icon" alt="" srcset="">
					</div>
					<div class="mentor_msgbox">
						<div class="mentor_title">
							{{item.title}}
						</div>
						<div class="mentor_subtitle">
							{{item.titles}}
						</div>
						<div class="mentor_msg">
							指导师级别:{{item.titles}}
						</div>
						<div class="mentor_msg">
							备案编号:{{item.zsbh}}
						</div>
						<!-- <div class="mentor_msg">
							发证日期:{{item.fzs_time}}
						</div>
						<div class="mentor_msg">
							所在机构:{{item.campname}}
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<div class="Home_column2" :style="screenWidth>785?'':'width:100%;'">
			<div class="column_titlebox"  v-if="screenWidth<785" :style="screenWidth>785?'':'width:100%;'" >
				<div class="column_title">
					研学机构
				</div>
				<div class="column_gomore" @click="goTravelerlist()">
					查看更多
				</div>
			</div>
			<div class="column_titleicon"  v-if="screenWidth>785"  @click="goTravelerlist()">
				<img src="../../../static/img/机构.jpg" alt="" srcset="">
			</div>
			<div class="column2_box">
				<div class="Traveler_item"   v-for="(item, key) in Travelerlist" :key="key"  @click="goTraveler(item.id)" >
					<div class="Traveler_title">
						{{item.title}}
					</div>
					<div class="Traveler_msg">
						{{item.address}}
					</div>
					<div class="Traveler_msg">
						电话: {{item.head_mobile}}
					</div>
				</div>
			</div>
		</div>
		<div class="Home_column2" :style="screenWidth>785?'':'width:100%;'">
			<div class="column_titlebox"  v-if="screenWidth<785" :style="screenWidth>785?'':'width:100%;'" >
				<div class="column_title">
					研学协会
				</div>
				<div class="column_gomore" @click="goTravelerlist()">
					查看更多
				</div>
			</div>
			<!-- <div class="column_titleicon"  v-if="screenWidth>785" >
				<img src="../../../static/img/协会.jpg" alt="" srcset="">
			</div>
			<div class="column2_box">
				<div class="intro_box">
					<img src="../../../static/img/logo44.jpg" alt="" class="intro_img">
					<div class="intro_msg">
						<div class="intro_title">河南省研学旅行教育协会简介</div>
						<div class="intro_content">河南省研学旅行教育协会是由河南师范大学牵头发起成立，河南省教育厅主管，相关单位及人士共同参与，联合推进我省中小学生研学实践教育高质量发展的社会组织。业务范围:研学政策研究、学术交流、人才培训、课程开发、线路规划、基地运营指导、企业咨询、研讨活动交流等。</div>
						<div class="intro_phonebox">
							<div class="intro_phone">咨培中心:13598089225</div>
							<div class="intro_phone">会员中心:16637190688</div>
							<div class="intro_phone">产品中心:18336055555</div>
							<div class="intro_phone">数据中心:18836901888</div>
							<div class="intro_phone">秘 书 处:18768879508</div>
							<div class="intro_phone">办公热线:0371-66305321</div>
						</div>
						<div class="intro_phone">电子邮箱:hnsyxlxjyxh@126.com</div>
						<div class="intro_phone" style="width: 100%;">秘书处地址:郑州市金水东路与民生路交叉口永和国际广场b区712室</div>
					</div>
				</div>
			</div> -->
		</div>
<!-- 		<div class="Home_column2">
			<div class="column_titlebox">
				<div class="column_title">
					研学产品
				</div>
				<div class="column_gomore">
					查看更多
				</div>
			</div>
			<div class="column2_box">
				<div class="product_box">
					<div class="prodduct_item" style="border-left: 0px;">
						<div class="prodduct_title" style="background: #e1251a; color: #ffffff;" >
							精选
						</div>
						<div class="product_msg" style="color: #e1251a;">
							猜你喜欢
						</div>
					</div>
					<div class="prodduct_item">
						<div class="prodduct_title">
							智能手环
						</div>
						<div class="product_msg">
							追踪定位
						</div>
					</div>
					<div class="prodduct_item">
						<div class="prodduct_title">
							研学保险
						</div>
						<div class="product_msg">
							安全保证
						</div>
					</div>
					<div class="prodduct_item">
						<div class="prodduct_title">
							研学百货
						</div>
						<div class="product_msg">
							研学用具
						</div>
					</div>
					<div class="prodduct_item">
						<div class="prodduct_title">
							研学拼团
						</div>
						<div class="product_msg">
							优惠抢拼
						</div>
					</div>
					<div class="prodduct_item">
						<div class="prodduct_title">
							积分商城
						</div>
						<div class="product_msg">
							其他
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<div class="Home_column2"  :style="screenWidth>785?'margin-top: 40px;':'margin-top: 30px;zoom:'+((screenWidth/1180)*100-3)+'%'">
			<div class="column2_box">
				
				
				
				<div class="column_blockimg" @click="gobottomnav(1,'/weus?title=关于我们')">
					<img src="../../../static/img/首页未定栏目4.jpg" alt="" srcset="">
				</div>
				<div class="column_blockimg" @click="gobottomnav(1,'/weus?title=入会申请')">
					<img src="../../../static/img/首页未定栏目2.jpg" alt="" srcset="">
				</div>
				<div class="column_blockimg" @click="gobottomnav(1,'/weus?title=在线留言')">
					<img src="../../../static/img/首页未定栏目1.jpg" alt="" srcset="">
				</div>
				<div class="column_blockimg"  @click="gobottomnav(1,'/weus?title=建议反馈')">
					<img src="../../../static/img/首页未定栏目3.jpg" alt="" srcset="">
				</div>
			</div>
		</div>
		<div :class="tops?'navbar':'navbar-top'" style="top: 68%;"  v-if="screenWidth>785">
<!-- 		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip> -->
			 <div  class="qrShow3 right2" style="top: calc(68% - 30px);"  v-if="showofficialQR">
			 	<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
			 </div>
			 <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showofficialQRCode" @mouseleave="hideofficialQRCode"><i class="el-icon-s-help"></i>  
			 			
			     <div style="font-size: 14px;">公众号</div></a>
		     <div  class="qrShow2 right2" style="top: calc(68% + 30px);;"  v-if="showserviceQR">
		     	<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		     <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
		     			
		         <div style="font-size: 14px;">客服</div></a>
		     <div  class="qrShow right" style="top: calc(68% + 90px);;" v-if="showQR">
				<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		     <!--    <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showQRCode" @mouseleave="hideQRCode"><i class="el-icon-mobile-phone"></i> 
					
		         <div style="font-size: 14px;">手机端</div></a> --> 
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
		<div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="(item, key) in bottomnav" :key="key" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="(item, key) in bottomnav" :key="key" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
		<div class="footer_box">
			<div class="row"  :style="screenWidth>785?'padding-bottom:0px':'width:calc(100% - 20px);padding:0px 10px;padding-bottom:0px'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						指导单位：河南省教育厅   主办单位：河南省研学旅行教育协会
					</div>
				</div>
				
			</div>
			<div class="row"  :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
		</div>
	</div>
	
	</div>

</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getBanner, getWxLogin, getAclist, getNewslist, getCategory, getCamplist, getActivitylist, getPac, getCourselist, getPc, getNt, getTeacher, getAdvbanner, getPlate,getLinelist,getTraveler,getRegion,getexpert,getbottomnav,getsitelist} from '@/request/api'
import { Loading } from 'element-ui';
// import MoveWindow from './moveWindow/MoveWindow.vue'
// import navTab from '../Navtab/navtab'
let _this=null
export default {
  name: "Home",
//   components: { MoveWindow },
  data(){
	  return {
	        // navList: ['标题1', '标题2', '标题3', '标题4'],
	        // navDropList: [{
	        //   title: '菜单1',
	        //   list: ['菜单标题1', '菜单标题2', '菜单标题3']
	        // }, {
	        //   title: '菜单2',
	        //   list: ['菜单标题1', '菜单标题2']
	        // }],
			// activeIndex: '1',
			title:'河南研学平台',
			top_search_url:'/Siteall',
			modules:'',
			activeIndex2: '/Home',
			Travelerlist:[],
			platelist:[],
			vTabs:false,
			phoneboxshow:false,
			userInfo: {
			  username: "",
			  education_name: "",
			  role_level: ""
			},
			stitle:'',
			Site_url: 'http://www.wanjiaxiao.net/',
			manage_url:'',
			manageoptions:[
				{
				  value: 'http://qianjin.wanjiaxiao.cn/',
				  label: '研学报备'
				}, {
				  value: 'https://admin.henanyanxue.com/',
				  label: '管理入口'
				},
			
			],
			Siteoptions:[
				{
				  value: 'http://www.wanjiaxiao.net/',
				  label: '研学总站'
				},
				//{
				 // value: 'http://www.wanjiaxiao.net/ms/',
				 // label: '密山研学'
				//},
			],
			vannavshow:false,
			vannavlist:[
				{
					link:'/Camplist',
					text:'营地列表'
				},
				{
					link:'/Baselist',
					text:'基地列表'
				},
				{
					link:'/Newslist',
					text:'资讯资讯'
				},
				{
					link:'/Courselist',
					text:'研学课程'
				},
				{
					link:'/Activitylist',
					text:'研学活动'
				},
				{
					link:'/Linelist',
					text:'研学线路'
				},
				{
					link:'/traveler',
					text:'研学机构'
				},
				{
					link:'/mentorlist',
					text:'研学指导师'
				},
				{
					link:'/expertlist',
					text:'专家团队'
				},
        {
          link: '/OrgRegister',
          text: '入驻平台'
        },
			],
			options: [{
							value: '/Siteall',
							label: '全站搜索'
						},{
			          value: '/Camplist',
			          label: '营地搜索'
			        }, {
			          value: '/Baselist',
			          label: '基地搜索'
			        }, {
			          value: '/Courselist',
			          label: '课程搜索'
			        },{
			          value: '/Newslist',
			          label: '资讯搜索'
			        },
					{
					  value: '/Activitylist',
					  label: '活动搜索'
					},
					{
					  value: '/Linelist',
					  label: '线路搜索'
					},
					{
					  value: '/traveler',
					  label: '机构搜索'
					},{
					  value: '/mentorlist',
					  label: '指导师搜索'
					},],
			        value: '',
			newstypes:[],
			Camplist:[],
			newscategory_id:0,
			logintype:true,
			banner:[
			],
			homeLoading: true,
			newslist:[],
			regionlist:[],
			expertlist:[],
			aclist:[],
			lessonlist:[],
			categorytypes:[],
			linelist:[],
			lessoncategory_id:0,
			pcsetdata:{},
			ntlist:[],
			mentorlist:[],
			mentor_index:'',
			mentorindex:0,
			mentortotal:0,
			advbanner:[],
			bottomnav:[],
			swiperexpert:{
				// loop: true,
				slidesPerview:'auto',
				// loopedSlides:7,
				autoplay:true,
				freeMode:true,
				width:165, 
				pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
					clickable: true
				},
				on:{
					transitionStart(){ // 开始translate之前触发
						// 如果是第一张
						if(this.activeIndex == 0){
							this.setTranslate(0); // 设置位移为0
						}
					},
					click(e) {
						// 使用e.target事件代理获取点击的元素，通过data语法获取元素的属性值
						let id = e.target.dataset.id;
						console.log(e.target.dataset)
						_this.goexpert(id)
						// 这里的this指向轮播,所以我在外边声明了_this用来代表vue实例
						// _this.goInto(url); // 跳转到详情页
					}
				}
			},
			swiperOption:{
				loop: true,
				slidesPerview:'auto',
				loopedSlides:4,
				autoplay: true,
				width:225, 
				pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
					clickable: true
				},
				on:{
					transitionStart(){ // 开始translate之前触发
						// 如果是第一张
						if(this.activeIndex == 0){
							this.setTranslate(0); // 设置位移为0
						}
					},
					click(e) {
						// 使用e.target事件代理获取点击的元素，通过data语法获取元素的属性值
						let id = e.target.dataset.id;
						console.log(e.target.dataset)
						_this.gocamp(id)
						// 这里的this指向轮播,所以我在外边声明了_this用来代表vue实例
						// _this.goInto(url); // 跳转到详情页
					}
				}
				
			},
			//侧边栏
			 showQR:false,
			  showserviceQR:false,
			  showofficialQR:false,
			tops:false,
			heights:window.innerHeight,
			scrolltop:'',
			//屏幕宽高
			// 屏幕宽度
			screenWidth: window.innerWidth,
			top_bannerWidth:Math.round(window.innerWidth/3.42),
			// 屏幕高度
			screenHeight: window.innerHeight,
	      }
  },
  created() {
	  _this =this
	  this.getpcset()
	   this.getsitelist()
	   setTimeout(() => {
	   		this.homeLoading = false
	   }, 1000)
  },
  mounted() {
	  const { code,state } = this.$route.query;
	  if(code){
		  console.log(111)
		  this.$router.push({
		    path: '/Login',
		    name: "/Login",
		    params: {
		      code,
			  state,
		    }
		  });
		  return
	  }
	  // 监听屏幕宽度和高度变化
	  // this.top_bannerWidth=window.innerWidth/3.42
	    window.addEventListener('resize', this.handleResize, true)
		
	  this.getPlate()
	  this.getRegion()
	  this.getexpert()
	  this.getinnovate()
	  // this.getnewstypes()
    this._getbanner() 
	this.getnewstypes()
	this._getCamplist()
	this._getAclist()
	this.getlessontypes()
	this.getlinelist()
	this.getmentor()
	this.getTraveler()
	this.getNt()
	this.getAdvbanner()
	this.getbottomnav()
	var token = localStorage.getItem('token')||''
	this.token=token
	// this.getlessonlist()
  window.addEventListener('scroll', this.scrollToTop)
  		
  },
   destroyed () {
          window.removeEventListener('scroll', this.scrollToTop)
    },
  // 销毁监听
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 保险投保跳转
    insureForm() {
      this.$router.push({
        path: "/InsureForm",
        name: "InsureForm",
        query: {}
      });
    },
	  getsitelist(){
	  		var list=this.Siteoptions
	  		getsitelist().then(res=>{
	  			for(var item of res.data.data){
	  				list.push({
	  					value:'http://www.wanjiaxiao.net/subsite/?region_type='+item.region_type,
	  					label:item.title
	  				})
	  			}
	  			this.Siteoptions=list
	  		})  
	  },
	  vanlinkgo(e){
		  console.log(e)
		  this.$router.push({
		    path: e.link,
		    name: e.link,
		    query: {
		    }
		  }); 
	  },
	  vannavmenushow(){
		this.vannavshow=false  
	  },
	  handleResize() {
		   this.top_bannerWidth = 0;
	    this.screenWidth = window.innerWidth;
		this.top_bannerWidth=window.innerWidth/3.42
		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
	    this.screenHeight = window.innerHeight;
	  },
	  manageurl(e){
		  console.log('Site',e)
		  if(e!='/'){
			   window.open(e) 
		  }
		//this.manage_url='/'
		  // window.location.href = e;
		  
	  },
	  Siteurl(e){
	  		console.log('Site',e)  
	  		window.location.href = e;
	  },
	  logout(){
	  			  var that=this
	  			  this.$confirm('是否确认退出登录?', '提示', {
	  			  					confirmButtonText: '确定',
	  			  					cancelButtonText: '取消',
	  			  					type: 'warning'
	  			  }).then(() => {
	  						this.$alert("已退出登录", '', {
	  							confirmButtonText: '确认',
	  							callback: action => {
	  								localStorage.setItem('token', '')
	  								localStorage.setItem('refreshToken', '')
	  								 that.$router.go(0)
	  							}
	  						  });
	  			  }).catch(() => {
	  			  		 
	  			  });
	  },
	  showQRCode(){//显示二维码
	          this.showQR = true
	      },
	      hideQRCode(){//隐藏二维码
	          this.showQR = false
	      },
	      scrollToTop () {
	          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
	          this.scrolltop = scrollTop
	          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
	              this.tops = true
	          } else {
	              this.tops = false
	          }
	      },
	      gotop () {
	          let timer = setInterval(() => {
	              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
	              if (this.scrolltop === 0) {
	                  clearInterval(timer)
	              }
	          }, 15)
	      },
	  getbottomnav(){
		  var data={
			  page_index:1,
			  page_size:15
		  }
		getbottomnav(data).then(res=>{
			this.bottomnav=res.data.data.list
		})  
	  },
	  gobottomnav(type,link){
		  if(type==1){
			  this.$router.push({
			  	path:link
			  });
		  }else if(type==2){
			  window.location.href = link;
		  }
	  },
	  goexpertlist(){
		  this.$router.push({
		  	path:'/expertlist',
		  	name:'/expertlist',
		  	query: {
		  	}
		  });
	  },
	  goexpert(id){
		  this.$router.push({
		  	path:'/expertdetails',
		  	name:'expertdetails',
		  	query: {
		  		id: id
		  	}
		  });
	  },
	  camptypego(id){
		  console.log(id)
		  this.$router.push({
		    path: '/Camplist',
		    name: "/Camplist",
		    query: {
		      region_type: id,
		    }
		  });
	  },
	  getRegion(){
	  			var data={
					page_size:10,
				}
	  			getRegion(data).then(res=>{
	  				var regionlist=[]
					var pagesize=0
					for(var item of res.data.data){
						console.log('item',item)
						if(pagesize<8){
							regionlist.push(item)
							
						}
						pagesize+=1
					}
					this.regionlist=regionlist
	  			})
	  },
	  gocolumn(url){
		  this.$router.push({
		    path: url,
		    name: url,
		    query: {
		    }
		  }); 
	  },
	  gotopsearch(){
		  this.$router.push({
		    path: this.top_search_url,
		    name: this.top_search_url,
		    query: {
		      stitle: this.stitle,
		    }
		  }); 
	  },
	  goTraveler(id){
		 this.$router.push({
		   path: "/travelerdetails",
		   name: "travelerdetails",
		   query: {
		     id: id
		   }
		 }); 
	  },
	  gomentor(){
		  this.$router.push({
		    path: "/mentorlist",
		    name: "/mentorlist",
		  		  query: {
		  		  }
		  });
	  },
	  goTravelerlist(){
		  this.$router.push({
		    path: "/traveler",
		    name: "/traveler",
		  		  query: {
		  		  }
		  });
	  },
	  getTraveler(){
		  var data={
		  	isshow:1,
			page_index:1,
			page_size:3,
			modules:this.modules,
		  }  
		  getTraveler(data).then(res=>{
			  this.Travelerlist=res.data.data.list
		  	// this.platelist=res.data.data
		  })
	  },
	  showofficialQRCode(){
		 this.showofficialQR=true
	  },
	  hideofficialQRCode(){//隐藏二维码
	      this.showofficialQR = false
	  },
	  showserviceQRCode(){
	  			  this.showserviceQR=true
	  },
	  hideserviceQRCode(){//隐藏二维码
	      this.showserviceQR = false
	  },
	  showphonebox(){
		this.phoneboxshow=true  
	  },
	  closephonebox(){
		this.phoneboxshow=false  
	  },
	  goregister(e){
	  			  this.$router.push({
	  			    path: "/register",
	  			    name: "/register",
	  			  		  query: {
	  			  		  }
	  			  });
	  },
	   showstep(ind) {
	        this.$refs.carousel.setActiveItem(ind)
	      },
		  goplate(id){
			  this.modules=id
			  this._getbanner()
			  
			  this.getnewstypes()
			  this._getCamplist()
			  this._getAclist()
			  this.getlessontypes()
			  this.getlinelist()
			  this.getmentor()
			  this.getTraveler()
		  },
	  getPlate(){
		var data={
			
		}  
		getPlate(data).then(res=>{
			this.platelist=res.data.data
		})
	  },
	  getlinelist(){
		  var data={
			  page_index: 1,
			  page_size: 4,
			  modules:this.modules,
			  is_pc:1,
		  }
		  getLinelist(data).then(res=>{
		  	console.log(res.data)
		  	this.linelist=res.data.data.list
		  	// this.quicklist=res.data.data.list
		  }).catch(error => {
		  	console.error(error);
		  });
	  },
	  getAdvbanner(){
		var data={
			is_pc:2,
			flag:'A'
		}  
		getAdvbanner(data).then(res=>{
			console.log('getAdvbanner',res)
			this.advbanner=res.data.data
		})
	  },
	  changementor(e){
		console.log('1112',e)  
		this.mentorindex=e+1
		this.getmentor()
	  },
	  mentoropen(index){
		this.mentor_index=index  
	  },
	  relist(data){
		  const list = data.split(',');
		  return list
	  },
	  getmentor(){
		  var data={
			  page_index:1,
			  page_size:3,
			  modules:this.modules,
		  }
		  getTeacher(data).then(res=>{
			  this.mentorlist=res.data.data.list
			  console.log("指导师",this.mentorlist)
		  })
	  },
	  getNt(){
		getNt().then(res=>{
			this.ntlist=res.data.data
		})  
	  },
	  getpcset(){
		getPc().then(res=>{
			this.pcsetdata=res.data.data
			document.title=res.data.data.title
		})  
	  },
	  golesson(e) {
	    this.$router.push({
	      path: "/CourseDetails",
	      name: "CourseDetails",
	      query: {
	        id: e
	      }
	    });
	  },
	  camptypetab(val){
		// this.lessoncategory_id=val
		this.getlessonlist()
	  },
	  getlessontypes(){
	  			var data={}
	  			getPac(data).then(res=>{
	  				console.log(res.data)
	  				this.categorytypes=res.data.data.cat
	  				// this.periodtypes=res.data.data.res
	  				// this.lessoncategory_id=res.data.data.cat[0].id
	  				this.getlessonlist()
	  			}).catch(error => {
	  			  console.error(error);
	  			});
	  },
	  getlessonlist(){
	  			var data={
	  				// type:this.camptype,
	  				category_id:this.lessoncategory_id,
	  				page_index: 1,
	  				page_size: 4,
					modules:this.modules,
	  			}  
	  			getCourselist(data).then(res=>{
	  				this.lessonlist=res.data.data.list
					// this.homeLoading = false
	  				// this.total=res.data.data.total
	  				// this.quicklist=res.data.data.list
	  			}).catch(error => {
	  				console.error(error);
	  			});
	  },
	  newshandleClick(e){
			console.log(e,this.category_id)
			this._getNewslist()
	  },
	  getnewstypes(){
		  var data={}
		  getCategory(data).then(res=>{
				  console.log(res.data)
				  var types=[
					{
					  id:'0',
					  icon:'',
					  title:'综合资讯'
					}
				  ]
				  for(var item of res.data.data){
					  types.push(item)
				  }
				  this.newscategory_id='0'
				  this.newstypes=types
				  this._getNewslist()
			}).catch(error => {
			  console.error(error);
			});
	  },
	  _getNewslist(){
		  var data={
			page_index:1,
			page_size:7,
			category_id:this.newscategory_id,
			modules:this.modules,
		  }
		getNewslist(data).then(res=>{
			console.log(res.data)
			this.newslist=res.data.data.list
		  }).catch(error => {
			  console.error(error);
			});
	  },
	  
	  getexpert(){
		  var data={
			page_index:1,
			page_size:20,
			modules:this.modules,
			type:1,
		  }
		  getexpert(data).then(res=>{
		  				 
		  	this.expertlist=res.data.data.list
			if(this.expertlist.length<8){
				this.swiperexpert.autoplay=false
			}
			console.log("专家团队",this.expertlist)
		  }).catch(error => {
		  				  console.error(error);
		  			});
	  },
	  getinnovate(){
	  		  var data={
	  			page_index:1,
	  			page_size:3,
	  			modules:this.modules,
	  			type:2,
	  		  }
	  		  getexpert(data).then(res=>{
	  		  				  console.log(res.data)
	  		  				  this.innovatelist=res.data.data.list
	  						  // if(this.expertlist.length<8){
	  							 //  this.swiperexpert.autoplay=false
	  						  // }
	  		  }).catch(error => {
	  		  				  console.error(error);
	  		  			});
	  },
	  _getCamplist(){
		  var data={
			  page_index:1,
			  page_size:8,
			  modules:this.modules,
		  }
		  getCamplist(data).then(res=>{
				  console.log(res.data)
				  this.Camplist=res.data.data.list
		  }).catch(error => {
		  				  console.error(error);
		  			});
	  },
	  _getAclist(){
		  var data={
			  page_index:1,
			  page_size:3,
			  modules:this.modules,
		  }
		  getAclist(data).then(res=>{
		  			  console.log(res.data)
					  this.aclist=res.data.data.list
		  			  // this.banner=res.data.data
		  }).catch(error => {
				  console.error(error);
			});
	  },
	  _getColumn(){
		  getColumn().then(res=>{
		  			  console.log(res.data)
		  			  // this.banner=res.data.data
		  }).catch(error => {
		  			  console.error(error);
		  			});
	  },
	  _getbanner(){
		  // console.log(22233, getBanner())
			var data={
				is_pc:2,
				modules:this.modules,
			}
		  getBanner(data).then(res=>{
			  console.log(res.data)
			  this.banner=res.data.data
		  }).catch(error => {
			  console.error(error);
			});
	  },
	handleSelect(key, keyPath) {
		console.log(key, keyPath);
	},
	golist(e){
		this.$router.push({
		  path: "/"+e,
		  name:"/"+e,
			query: {
			}
		});
	},
	gontdetails(e){
		this.$router.push({
		  path: "/Ntdetails",
		  name: "Ntdetails",
		  query: {
		    id: e
		  }
		});
	},
    gonews(e,link){
		if(link){
			window.location.href=link
		}else{
			this.$router.push({
		  path: "/NewsDetails",
		  name: "NewsDetails",
		  query: {
		    id: e
		  }
		});
		}
		
	},
	gocamp(e){
		console.log(e)
		this.$router.push({
		  path: "/CampDetails",
		  name: "CampDetails",
		  query: {
		    id: e,
		  }
		});
	},
	goline(e){
		this.$router.push({
		  path: "/LineDetails",
		  name: "LineDetails",
		  query: {
		    id: e
		  }
		});
	},
	goactivity(e){
		this.$router.push({
		  path: "/Activitydetails",
		  name: "Activitydetails",
		  query: {
		    id: e
		  }
		});
	},
	gomodules(e){
		console.log("link");
		console.log(e);
		if(e){
			window.location.href = e;
			//this.$router.push(e);
		}
	},
  }
};
	
</script>

<style scoped>
	.column_titleicon{
		width: 1180px;
		height: 60px;
	}
	.column_titleicon img{
		width: 100%;
		height: 100%;
	}
	.expert_box{
		border: 1px solid #f4f4f4;
		position: relative;
		box-sizing: border-box;
		overflow: hidden;
		border-top: none;
		padding: 20px 15px 20px;
		/* margin:0px 10px; */
		margin-top: -10px;
		/* margin-left: 12px; */
		z-index: 99;
	}
	.homecamp_item{
		width: 210px;
		height: 310px;
		border-radius: 5px;
		background: #ffffff;
		margin-right: 15px;
	}
	.expert_item{
		width: 150px;
		height: 250px;
		border-radius: 5px;
		background: #f9f9f9;
		margin-right: 15px;
	}
	.expert_img{
		width: 100%;
		height: 202.5px;
		border-radius: 5px 5px 0px 0px;
	}
	.expert_img img{
		width: 100%;
		height: 100%;
		border-radius: 5px 5px 0px 0px;
	}
	.home_banner_text{
		width: 100%;
		    padding: 4px 0;
		    background: rgba(71,86,105,.51);
		    color: #fff;
		    text-align: center;
		    position: absolute;
		    bottom: 0;
		    height: 18px;
		    line-height: 18px;
		    font-size: 14px;
	}
	body{
		background: #ffffff;
	}
	#appbox{
		background: #ffffff;
	}
	.Home_column1{
		width: 1180px;
		display: flex;
		margin: 0 auto;
		justify-content: space-between;
		margin-top: 50px;
	}
	.Home_column2{
		width: 1180px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.Home_Notice{
		width: 1140px;
		padding: 0px 20px;
		color: #1b9d57;
		display: flex;
		font-size: 18px;
		align-items: center;
		margin: 0 auto;
		margin-top: 20px;
		 box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		 
	}
	.Notice_list{
		width: 1100px;
		text-align: left;
		margin-left: 10px;
	}
	::v-deep .Notice_list>.el-carousel>.el-carousel__container>.el-carousel__item{
		    background-color: #ffffff !important;
	}
	.Home_advimgs{
		width: 1180px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.column_titlebox{
		width: 100%;
		padding: 20px 0px;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.column_title{
		font-size: 22px;
		color: #1b9d57;
	}
	.column_right{
		display: flex;
		align-items: flex-end;
		
	}
	.column_right:first-child {
		 border-left: 0px !important;
	  /* 父元素的第一个子元素的样式 */
	}
	.mentor_type{
		padding: 0px 10px;
		font-size: 16px;
		border-left: 1px solid #606266;
		color:#606266 ;
	}
	.gomore_mentor{
		margin-left: 20px;
		font-size: 14px;
		color:#606266 ;
	}
	.column_gomore{
		text-align: right;
		font-size: 16px;
		color: #C0C4CC;
	}
	.column2_box{
		width: 100%;
	
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.homecamp_list{
		width: calc(100% - 20px );
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #f9f9f9;
	}
	.camp_swiperbox{
		display: flex;
		flex: 1;
		max-width: 890px;
		margin-right: 30px;
	}
	.camp_titleicon{
		width: 250px;
		height: 310px;
		border-radius: 5px;
		position: relative;
	}
	.camp_titleicon img{
		width: 100%;
		height: 100%;
		border-radius: 5px;
	}
	.camp_regionbox{
		padding: 40px;
		    padding-top: 90px;
		    position: absolute;
		    top: 0px;
		    left: 0px;
		    width: 170px;
		    height: 180px;
		    overflow: hidden;
		    display: flex;
		    flex-wrap: wrap;
		    justify-content: space-between;
		
	}
	.camp_regionitem{
		font-size: 16px;
		color: #1b9d57;
		    height: 28px;
		    width: 80px;
		/* margin-bottom: 10px; */
	}
	.camp_regionitem:hover{
		color:#1b9d57 !important;
		
	}
	.column_blockimg{
		width: 285px;
		 box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}
	
	.product_box{
		width: 1180px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #EBEEF5;
		padding: 15px 0px;
		border-radius: 5px;
		/* height: ; */
	}
	.prodduct_item{
		width: 195px;
		height: 60px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		border-left: 1px solid #EBEEF5;
	}
		
	.prodduct_title{
		padding: 4px 10px;
		border-radius: 10px;
		margin-bottom: 4px;
		font-size: 18px;
		font-weight: 600;
		color: #303133;
	}
	.product_msg{
		font-size: 14px;
		color: #909399;
	}
	
	.mentor_item{
		padding: 20px;
		width: 330px;
		display: flex;
		align-items: center;
		background: #f9f9f9;
		border-radius: 8px;
	}
	.mentor_imgs{
		width:100px;
		height: 135px;
	}
	.mentor_imgs img{
		border-radius: 5px;
		width: 100%;
		height: 100%;
	}
		
	.mentor_msgbox{
		margin-left: 20px;
		flex: 1;
		max-width: 210px;
		display: flex;
		flex-direction: column;
		
	}
	.mentor_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		text-align: left;
	}
	.mentor_subtitle{
		font-size: 15px;
		color: #909399;
		margin: 10px 0px;
		text-align: left;
	}
	.mentor_msg{
		font-size: 12px;
		color: #909399;
		margin: 1px;
		text-align: left;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		
	}
	.mentor_msg2{
		font-size: 12px;
		color: #909399;
		margin: 1px;
		text-align: left;
	}
	.Traveler_item{
		padding: 20px;
		width: 340px;
		background: #f9f9f9;
		border-radius: 8px;
	}
	.Traveler_title{
		width: 100%;
		font-size: 18px;
		color: #303133;
		text-align: left;
		margin-bottom: 10px;
	}
	.Traveler_msg{
		width: 100%;
		font-size: 14px;
		color: #909399;
		text-align: left;
	}
	.prodduct_item{
		
	}
	.column2_item{
		width: 265px;
		height: 260px;
		border-radius: 15px;
		position: relative;
	}
	.column2_item_phone{
		width: 132px;
		height: 130px;
		border-radius: 15px;
		position: relative;
	}
	.camp_rank{
		position: absolute;
		left: 0px;
		top: 0px;
		padding: 4px 8px;
		font-size: 14px;
		border-radius: 10px 0px;
		    background: #fe3113;
		    color: #ffffff;
	}
	.column2_img{
		width: 100%;
		height: 180px;
	}
	.column2_img_p{
		width: 100%;
		height: 90px;
	}
	.column2_img img{
		width: 100%;
		height: 100%;
		border-radius:10px 10px 0px 0px;
	}
	.column2_img_p img{
		width: 100%;
		height: 100%;
		border-radius:10px 10px 0px 0px;
	}
	.column2_title{
		padding: 10px;
		background: #f9f9f9;
		border-radius: 0px 0px 10px 10px;
		padding-bottom: 15px;
	}
	.hcamp_title{
		padding: 10px;
		border-radius: 0px 0px 10px 10px;
		padding-bottom: 15px;
	}
	.item_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		margin-bottom: 15px;
		text-align: left;
		overflow: hidden;
		    white-space: nowrap;
		    text-overflow: ellipsis;
		/* text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical; */
	}
	.item_subtitle{
		font-size: 14px;
		color: #909399;
		text-align: left;
		overflow: hidden;
		    white-space: nowrap;
		    text-overflow: ellipsis;
	}
	.homecamp_msg{
		font-size: 14px;
		color: #909399;
		text-align: left;
	}
	.hcamp_button{
		display: flex;
		    padding: 0px 10px;
	}
	
	
	.Home_imgs{
		width: 575px;
		
	}
	.newnews_box{
		width: 580px;
	}
	.news_top{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.news_title{
		padding: 15px;
		border-bottom: 2px solid #1b9d57;
		color: #1b9d57;
		font-size: 22px;
		font-weight: 600;
	}
	.news_gomroe{
		padding: 17px 0px;
		text-align: right;
		flex: 1;
		font-size: 16px;
		border-bottom: 1px solid #E4E7ED;
		color: #C0C4CC;
	}
	.newslist{
		width: 100%;
		display: flex;
		flex-direction: column;
		margin: 0px;
	}
	.news_item{
		text-align: left;
	}
	
	
	
	.plate_icon{
		
	}
	
	
	
	
	.el-tag--mini{
		font-size: 8px !important;
		    padding: 0 2.8px;
	}
	.mentor{
		width: 1100px;
		margin: 0 auto;
		margin-top: 20px;
		
	}
	.mentor_box{
		width: 1100px;
		display: flex;
		/* justify-content: ; */
		flex-wrap: wrap;
		
		background: #30313336;
	}
	.mentor_msg_box{
		position: absolute;
		width: 180px;
		height: 245px;
		background: #333333c7;
		color: #ffffff;
		top: 0px;
		    left: 0px;
	}
/* 	.mentor_title{
		padding:15px 10px;
		margin: 0px 10px;
		margin-top: 50px;
		font-size: 20px;
		font-weight: 500;
		border-bottom: 1px solid #ffffff;
	} */
	.mentor_tags{
		padding: 9px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.mentor_camp{
		font-size: 14px;
		text-align: left;
		padding: 10px;
		padding-top: 0px;
	}
	.ntmain{
		width: 1000px;
	}
	.nttext:hover{
		color: #1b9d57 !important;
	}
	.ntbox{
		width: 1060px;
		    background: #ffffff;
		    margin: 10px auto;
		    display: flex;
		    align-items: center;
		    padding: 0px 20px;
	}
	.nticon{
		width: 30px;
		height: 30px;
		margin-right: 10px;
	}

	.lessonbox{
		width: 1100px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.home_titlebox{
		width: 1100px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.next_text{
		margin-bottom: 20px;
		font-size: 16px;
	}
	.camplist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}
	.lessonlist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		flex-wrap: wrap;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.actlist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		flex-wrap: wrap;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.actmsgbox{
		width: 320px;
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.actbutton{
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		color: #ffffff;
		background: #1b9d57;
	}
	.actbutton2{
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		color: #ffffff;
		background: #9e9e9e;
	}
	.actbox{
		width: 1100px;
		margin-top: 20px !important;
		margin: 0 auto;
	}
	.campitem{
		width: 340px;
		border-radius: 8px;
			color: #333;
	}
	.lessonitem{
		width: 257px;
		margin-bottom: 10px;
		color: #333;
	}
	.lessonitem:hover{
		color: #1b9d57;
	}
	.campitem:hover{
		color: #1b9d57;
	}
	.lessonimgbox{
		width: 257px;
		height: 177px;
		position: relative;
	}
	.lessonimgbox img{
		width: 100%;
		height: 100%;
	}
	.campimgbox{
		width: 340px;
		height: 168px;
		position: relative;
		
	}
	.actimgbox{
		width: 340px;
		height: 218px;
	}
	.actimgbox img{
		width: 100%;
		height: 100%;
	}
	.actpay{
		font-size: 14px;
		color: brown;
	}
	
	.campimgbox img{
		width: 100%;
		height: 100%;
		border-radius: 8px 8px 0px 0px;
	}
	.campaddress{
		width: 320px;
		position: absolute;
		bottom: 0;
		right: 0;
		z-index: 1;
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
		font-size: 12px;
		font-weight: 600;
		color: #ffffff;
		height: 26px;
		line-height: 26px;
		padding: 0 10px;
		background: #30313336;
	}
	.camptitle{
		padding: 10px;
		font-size: 18px;
		width: 320px;
		height: 46px;
	
		/* margin-bottom: 15px; */
		text-align: left;
		/* height: 50px; */
		/* line-height: 50px; */
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.lessontitle{
		padding: 10px;
		font-size: 18px;
		width: 237px;
		height: 46px;
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	
	.imgsbox{
		/* width:1100px; */
		/* margin: 10px auto; */
	}
	.advbanner{
		width:1100px;
		margin: 0px auto;
	}
	.newsimgH{
		width: 210px;
		height: 135px;
		background-color: #333;
	}
	.newsitemH{
		width: 525px;
		padding: 10px;
		border-radius: 8px;
		display: flex;
		/* justify-content: ; */
		
		align-items: center;
		margin-bottom: 10px;
		background: #ffffff;
	}
	.newsitemH:hover{
		color: #1b9d57;
	}
	.newsitembox{
		width: 100%;
		margin-top: 10px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}
	.newsmsgH{
		width: 280px;
		height: 135px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
	}
	.news_bottomH{
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
	.newstitle{
		font-size: 18px;
		
	}
	.campbox{
		width: 1100px;
		margin: 0 auto;
	}
/* 	::v-deep .el-tabs__header{
		margin: 0px !important;
	} */
	.el-tabs__item{
		font-size: 18px;
		/* padding:30px ; */
	}
	::v-deep .el-tabs__item.is-active{
		color: #1b9d57;
	}
/* 	::v-deep .el-tabs__active-bar{
		width: 112px !important;
	} */
/* 	.el-tabs__content{
		background: #f5f5f5;
	} */
</style>

<style>

/* 	.top_banner>.el-carousel>.el-carousel__indicators--horizontal{
		bottom: 180px;
	} */

	
	.el-tabs__active-bar{
		background-color: #1b9d57 !important;
	}
	.el-tabs__item{
		padding-left: 20px !important;
	}
	.el-tabs__nav-wrap{
		background: #ffffff;
	}
	
	.newsbox{
		width: 1100px;
		margin: 10px auto;
		display: flex;
	}
	.video{
		width: 50%;
		height: 350px;
		background-color: #333;
		margin-left: 10px;
	}
	.video video{
		width: 100%;
		height: 100%;
	}
	.news_box{
		display: flex;
		min-height: 400px;
		width: 100%;
		/* background: #ffffff; */
	}
	.news_item{
		padding: 10px;
		color:#333;
		width: 95%;
		border-bottom: 1px solid #d3d3d326;
		overflow: hidden;
		   white-space: nowrap;
		   text-overflow: ellipsis;
	}
	.news_item:hover
	{ 
		color:#1b9d57;
	    background-color:#d9f8fa;
	}
	.newslefticon{
		width: 80px;
		height: 350px;
		writing-mode: vertical-lr;
		writing-mode: tb-lr;
		color: #ffffff;
		font-weight: 600;
		background: #3a8ee6;
		font-size: 30px;
		line-height: 80px;
		margin-left: 10px;
		margin-right: 10px;
	}
	.newslefticon img{
		width: 100%;
		height: 100%;
	}
	.actslefticon{
		width: 80px;
		height: 350px;
		writing-mode: vertical-lr;
		writing-mode: tb-lr;
		color: #ffffff;
		font-weight: 600;
		background: #3a8ee6;
		font-size: 30px;
		line-height: 80px;
		/* margin-left: 10px; */
		margin-right: 10px;
	}
	.actslefticon img{
		width: 100%;
		height: 100%;
	}
	.news_list{
		/* width: 40%; */
		width: 455px;
		height: 350px;
		/* border-radius: 10px; */
		    box-shadow: 2px -2px 14px 6px #3a8ee626;
			background: #ffffff;
		/* background:; */
	}
	.newsbox .el-carousel--card{
		width: 100%;
	}
	

	
	/* 图片轮播 */
	 .el-carousel__item h3 {
	    color: #475669;
	    font-size: 14px;
	    opacity: 0.75;
	    line-height: 150px;
	    margin: 0;
	  }
		
	  .el-carousel__item:nth-child(2n) {
	     background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	     background-color: #d3dce6;
	  }
	  @media only screen and (max-width: 768px){ /* 在小于等于768px的设备上执行该CSS代码 */
	  
	  	.el-tabs__item{
	  		font-size: 16px;
			padding: 0px;
	  	}
	
	  }
	  .intro_box{
		display: flex;
		justify-content: space-between;
		/* font-family: "楷体", "KaiTi", "SimKai", serif; */
		/* align-items: center; */
		
	  }
	  .intro_img{
		width: 280px;
		height: 280px;
		
	   }
	   .intro_title{
		font-size: 28px;
		color: rgb(32, 150, 150);
		margin-bottom: 15px;
	
	   }
	   .intro_content{
		text-indent: 2em;
		text-align: start;
		font-size: 18px;
		letter-spacing: 1px;
		line-height: 25px;
		color: #333;
	   }
	   .intro_phonebox{
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	   }
	   .intro_phone{
		width: 33%;
		text-align: start;
		margin-top: 10px;
		font-size: 18px;
		letter-spacing: 1px;
	   }

</style>